import { Box, Heading } from '@everlywell/ui-kit';
import React from 'react';
import { Order } from 'utils/types';

import CartPromoCode from '../CartPromoCode';
import CartSpinner from '../CartSpinner';
import CartSummary from '../CartSummary/CartSummary';

export type CartSummaryProps = { order: Order };

/**
 * Card Summary Card component used for mobile.
 */
function CartSummaryCard({ order }: CartSummaryProps): JSX.Element {
  const [isLoading, setIsLoading] = React.useState(false);

  return (
    <Box>
      <Heading as="h3" size="md" marginBottom={3}>
        Order Summary
      </Heading>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="stretch"
        background="tints.lightCream"
        border="1px solid"
        borderColor="tints.darkCream"
        borderRadius={12}
        position="relative"
        paddingY={5}
        paddingX={4}
        gap={6}
      >
        <CartPromoCode onLoadingChange={setIsLoading} />
        <Box as="hr" borderColor="tints.darkCream" />
        <CartSummary.Details order={order} />
        <Box as="hr" borderColor="tints.darkCream" />
        <CartSummary.Total order={order} />
        {isLoading ? <CartSpinner /> : null}
      </Box>
    </Box>
  );
}

export default CartSummaryCard;
